module.exports = __webpack_public_path__ + "static/marketing-min-1134e62d16c2add38249906fd55a6576.jpg";